import { render, staticRenderFns } from "./DraggableMergingHeaderTable.vue?vue&type=template&id=187747ae"
import script from "./DraggableMergingHeaderTable.vue?vue&type=script&lang=js"
export * from "./DraggableMergingHeaderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports